import { Loader, Tooltip } from "@mantine/core";
import { IconDeviceFloppy, IconLock } from "@tabler/icons-react";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useIsOnline } from "src/hooks";
import { useSelector } from "src/redux/hooks";

const EntryLockInfo = () => {
  const lbName = useSelector(state => state.generatorSlice.latestEntry.lbName);
  const { locked, user, you, isSaving, activeAutosave, lastUpdate } =
    useSelector(state => state.entrySlice);
  const location = useLocation();
  const pendingAutosaves = useSelector(state =>
    state.pendingRequestsSlice.pendingRequests.some(
      request =>
        request.isAutosave &&
        request.status !== "done" &&
        request.route === location.pathname,
    ),
  );
  const isOnline = useIsOnline();

  const lockedBy = useMemo(
    () =>
      you ? "by You" : user ? `by ${user.rolename} - ${user.full_name}` : "",
    [you, user],
  );

  return (
    <>
      {lbName && locked && (
        <Tooltip
          color="dark"
          label={
            isOnline
              ? `Entry is locked for editing ${lockedBy}`
              : "Entry is locked for offline editing"
          }>
          <IconLock color={you ? "green" : "red"} />
        </Tooltip>
      )}
      {!isOnline && pendingAutosaves && (
        <Tooltip color="dark" label="Autosaved offline · Waiting to sync">
          <IconDeviceFloppy color="orange" />
        </Tooltip>
      )}
      {activeAutosave && isSaving && <Loader size="sm" color="green" />}
      {activeAutosave && !isSaving && lastUpdate && (
        <Tooltip color="dark" label={`Last saved: ${lastUpdate}`}>
          <IconDeviceFloppy color="green" />
        </Tooltip>
      )}
    </>
  );
};

export default EntryLockInfo;
